import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

export type MetricCardTone = 'default' | 'success' | 'warning' | 'danger';
export type MetricCardToneExtended = MetricCardTone | 'neutral';

export interface MetricCardItem {
  key: string;
  label?: string;
  labelKey: string;
  value: string | number;
  detail?: string | null;
  tone?: MetricCardToneExtended;
}

@Component({
  selector: 'app-metric-cards',

  imports: [CommonModule, TranslatePipe],
  templateUrl: './metric-cards.component.html',
  styleUrl: './metric-cards.component.scss',
})
export class MetricCardsComponent {
  items = input<MetricCardItem[]>([]);
  compact = input(false);
  scrollRow = input(false);

  resolveLabel(item: MetricCardItem): string {
    return item.label ?? item.labelKey;
  }
}
